export default __webpack_public_path__ + "52065b258d9e38c3dc278d0049cbab22.png";